import { FSEAuthRoutes } from '@agco-onedigital/ecosystem-lib-frontend-utils';

export interface IFeatureMapping {
  name: string;
  route: string;
  alertName: string; // Feature name with -alert postfix for tracking modal display
}

export const FEATURE_MAPPINGS: Record<string, IFeatureMapping> = {
  VIDEOS: {
    name: 'videos',
    route: FSEAuthRoutes.VIDEOS,
    alertName: 'videos-alert',
  },
  // Add more features here as needed
  // MANUALS: {
  //   name: 'manuals',
  //   route: FSEAuthRoutes.MANUALS,
  //   alertName: 'manuals-alert',
  // },
};

export const getFeatureByRoute = (route: string): IFeatureMapping | undefined => {
  return Object.values(FEATURE_MAPPINGS).find(feature => feature.route === route);
};

export const getFeatureByName = (name: string): IFeatureMapping | undefined => {
  return Object.values(FEATURE_MAPPINGS).find(feature => feature.name === name);
};

export const hasUserVisitedFeature = (featureName: string, userFeatures: string[] = []): boolean => {
  return userFeatures.includes(featureName);
};

export const hasUserSeenAlert = (alertName: string, userFeatures: string[] = []): boolean => {
  return userFeatures.includes(alertName);
};
